import { render, staticRenderFns } from "./NotFoundCard.vue?vue&type=template&id=c7f0e2bc&scoped=true"
import script from "./NotFoundCard.vue?vue&type=script&lang=js"
export * from "./NotFoundCard.vue?vue&type=script&lang=js"
import style0 from "./NotFoundCard.vue?vue&type=style&index=0&id=c7f0e2bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f0e2bc",
  null
  
)

export default component.exports